module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-4.31d860a8.webp";